"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _tinyInvariant = _interopRequireDefault(require("tiny-invariant"));

var _deburr = _interopRequireDefault(require("lodash/deburr"));

var _has = _interopRequireDefault(require("lodash/has"));

var _translate = _interopRequireDefault(require("./translate"));

function guesFieldName(source) {
  if ((0, _has.default)(source, 'label')) {
    return 'label';
  }

  if ((0, _has.default)(source, 'name')) {
    return 'name';
  }

  throw Error('convertToSearchable(...) property `label` or `name` not found in source. ' + 'Please provide fieldName as function parameter.');
}

function createSearchValue(s) {
  return (0, _deburr.default)((s || '').toLowerCase());
}

function createSearchableObject(source, fieldName, original, translated) {
  var _extends2;

  return (0, _extends3.default)({}, source, (_extends2 = {}, (0, _defineProperty2.default)(_extends2, fieldName, translated), (0, _defineProperty2.default)(_extends2, "search", createSearchValue(translated)), (0, _defineProperty2.default)(_extends2, "original", original), _extends2));
}

function convertObject(fieldName, source, _ref) {
  var disableSearchFieldTranslation = _ref.disableSearchFieldTranslation;
  var fFieldName = fieldName || guesFieldName(source);
  (0, _tinyInvariant.default)((0, _has.default)(source, fFieldName), "convertToSearchable(...) source object doesn't have own property ".concat(fFieldName));
  return createSearchableObject(source, fFieldName, source[fFieldName], disableSearchFieldTranslation ? source[fFieldName] : (0, _translate.default)(source[fFieldName], {
    acceptString: true
  }));
}

var convertObjectMapper = function convertObjectMapper(fieldName, options) {
  return function (source) {
    return convertObject(fieldName, source, options);
  };
};
/**
 * Skonvertuje `source` parameter, ktery muze byt `string`, `Object`, nebo `Array<Object>`.
 *
 * __Priklad prekladu objektu__:
 * Vstup:
 * ```js
 * {
 *   id,
 *   code,
 *   label,
 * }
 * ```
 *
 * Vystup:
 * ```js
 * {
 *   id,
 *   code,
 *   label, // prelozeny
 *   search, // vyhladavaci text
 *   original, // povodna hodnota
 * }
 * ```
 *
 * @param {string | Object | Object[]} source Zdroj
 * @param {string} [fieldName] Custom nazev fieldu v `source` objektu. Pokud neni definovan, probehne pokus o resolve
 *                             fieldu `label` a pak `name`. Predpoklada se, ze hodnotou fieldu je `TranslateDictionary`.
 * @param {Object} [options]
 * @param {boolean} [options.disableSearchFieldTranslation] Pokud je `true` hodnota `searchFiled` se nebude prekladat.
 *
 * @returns {Object} Vysledkem pro vstupni `string` je `{ search, original, translated }`. Pro vstupni `Object` je
 *                   `Object` rozsireny o fieldy `search` a `original`, pricemz ve `fieldName` je preklad.
 */


function convertToSearchable(options, source, fieldName) {
  (0, _tinyInvariant.default)(source, "convertToSearchable(...) 'source' param is requred.");

  if (typeof source === 'string') {
    return createSearchableObject(undefined, 'translated', source, source);
  }

  if (Array.isArray(source)) {
    return source.map(convertObjectMapper(fieldName, options || {}));
  }

  if ((0, _typeof2.default)(source) === 'object' && source !== null) {
    return convertObject(fieldName, source, options || {});
  }

  throw Error("convertToSearchable(...) 'source' value is not supported.");
}

var _default = convertToSearchable;
exports.default = _default;